import { useState } from "react";
import { IconHeader, Alert } from "../../../../../components";
import { FormCheckboxGroup, FormRadioGroup } from "../../../../../features/auto-form";
import FormRoomTypeSelection from "../../../../../modules/custom-form-modules/form-room-type-selection/form-room-type-selection";
import { useTranslate } from "../../../../../features/translation/hooks/use-translation"

const AccommodatonRoomOccupancy = (props) => {
    const [displaySingleRoomChoice, setDisplaySingleRoomChoice] = useState(false)
    const [displayMultiBedChoice, setDisplayMultiBedChoice] = useState(false)
    const [displayApartmentChoice, setDisplayApartmentChoice] = useState(false)
    const { t } = useTranslate(); 


    const handleAdd = (value) => {
        if (value === "singleRoom" && !displaySingleRoomChoice){
            setDisplaySingleRoomChoice(true)
        }

        if (value === "multiBedRoom"  && !displayMultiBedChoice) {
            setDisplayMultiBedChoice(true)
        }
        if ( value === "apartment" && !displayApartmentChoice) {
            setDisplayApartmentChoice(true)
        }
    }

    const handleRemove = (value) => {
        if (value === "singleRoom" && displaySingleRoomChoice){
            setDisplaySingleRoomChoice(false)
        }

        if (value === "multiBedRoom" && displayMultiBedChoice) {
            setDisplayMultiBedChoice(false)
        }
        if ( value === "apartment" && displayApartmentChoice) {
            setDisplayApartmentChoice(false)
        }
    }
  
    return (
        <div className="container">
            <div className="row">
                <div className="col col-12">
                    <IconHeader title={t("form.accommodationPreferences.roomOccupancy.title")} icon="bed" />
                </div>
            </div>
            <div className="row">
                <div className="col col-12">
                    <div 
                    className="text base"
                    dangerouslySetInnerHTML={{ __html: t("form.accommodationPreferences.roomOccupancy.description") }} />
                </div>
            </div>
            <div className="row">
                <div className="col col-12">
                    <FormRoomTypeSelection
                        name="request.accommodation.roomType"
                        languagesection= "form.accommodationPreferences.roomOccupancy"
                        options={[
                            { label: "Single room", value:"singleRoom", icon:"user", description:"lorem"},
                            { label: "Double room", value:"doubleRoom", icon:"users", description:"lorem"},
                            { label: "Multibed room", value:"multiBedRoom", icon:"user-family", description:"lorem"},
                            { label: "Apartment", value:"apartment", icon:"home", description:"lorem"}
                        ]}
                        onAdd={handleAdd}
                        onRemove={handleRemove}
                        required
                    />
                </div>
            </div>
            {displaySingleRoomChoice &&
            <div className="row">
                <div className="col col-12">
                    <Alert
                        type="info"
                        label={t("form.accommodationPreferences.roomOccupancy.title")}
                 
                    >
                    <div dangerouslySetInnerHTML={{ __html: t("form.accommodationPreferences.roomOccupancy.singleRoomTypes.description") }} />
                    <FormRadioGroup 
                            name="request.accommodation.singleRoomTypes"
                            label=""
                            languagesection="form.accommodationPreferences.roomOccupancy.singleRoomTypes"
                            options={[
                                { value:"singleRoomOnly"},
                                { value:"doubleRoomForSingleOccupancy"},
                                { value: "singleRoomAndDoubleRoomForSingleOccupancy"},
                            ]}
                            required
                        />

                    </Alert>
                </div>
            </div>
            }
            {(displayApartmentChoice || displayMultiBedChoice) &&
            <div className="row">
                <div className="col col-12">
                    <Alert
                        type="info"
                        label= {t("form.accommodationPreferences.roomOccupancy.title")}
                    >
                    <div dangerouslySetInnerHTML={{ __html:t("form.accommodationPreferences.roomOccupancy.multiBedRoomTypes.description")}} />
                    <FormCheckboxGroup
                            name="request.accommodation.multiBedRoomTypes"
                            languagesection= "form.accommodationPreferences.roomOccupancy.multiBedRoomTypes"
                            options={[
                                { label: "Bed sofa", value:"bedSofa"},
                                { label: "Extra bed", value:"foldableBed"},
                                { label: "Bunk beds", value:"bunkBed"}
                               
                            ]}
                        />

                    </Alert>
                </div>
            </div>
}
        </div>
    )
}

export default AccommodatonRoomOccupancy;

/*

const SingleRoom = () => {
    
    return (
        <MultiCard
            label="Single room"
            description="Single rooms description"
            icon="user"
        >
                <FormRadioGroup 
                    label="I am open to:"
                    name="singleRoomOptions"
                    options={[
                        {label:"Single occupancy in double rooms to full price", value:"doubleToFull"},
                        {label:"Only single rooms", value:"singlerooms"}

                    ]}
                />
  
        </MultiCard>
    )
}

const DoubleRoom = () => {

    return (
        <MultiCard
        label="Double room"
        description="Double rooms description"
        icon="users"
        />
    )
}

const Appartment = () => {
    return (
        <MultiCard
            label="Multi room appartment"
            description="Multi rooms description"
            icon="home"
        >
                <FormCheckboxGroup
                    label="I am open to:"
                    name="singleRoomOptions"
                    options={[
                        {label:"Single occupancy in double rooms to full price", value:"doubleToFull"},
                        {label:"Only single rooms", value:"singlerooms"}

                    ]}
                />
  
        </MultiCard>
    )
}

const MultiBed = () => {

    return (
        <MultiCard
        label="Multi bed room"
        description="Multi bed room description"
        icon="user-family"
    >
            <FormCheckboxGroup
                label="I am open to:"
                name="singleRoomOptions"
                options={[
                    {label:"Single occupancy in double rooms to full price", value:"doubleToFull"},
                    {label:"Only single rooms", value:"singlerooms"}
                ]}
            />

    </MultiCard>
    )
}



*/